<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<crucible-dialog
  [dialogTitle]="(data.unit.id ? 'Edit' : 'Add') + ' Unit'"
  [submitDisabled]="!errorFree()"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
  @if (!!data && data.unit !== undefined && data.unit !== null) {
    <div crucibleDialogContent>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input type="text" matInput [formControl]="unitNameFormControl" placeholder="Name (required)" (blur)="saveUnit('name')"
              value="{{data.unit.name}}">
            @if (unitNameFormControl.hasError('minlength') && !unitNameFormControl.hasError('required')) {
              <mat-error>
                Must contain {{ MIN_NAME_LENGTH }} or more characters
              </mat-error>
            }
            @if (unitNameFormControl.hasError('required')) {
              <mat-error>
                Name is <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Short Name</mat-label>
            <input type="text" matInput [formControl]="unitShortNameFormControl" placeholder="Short Name (required)" (blur)="saveUnit('shortName')"
              value="{{data.unit.shortName}}">
            @if (unitShortNameFormControl.hasError('minlength') && !unitShortNameFormControl.hasError('required')) {
              <mat-error>
                Must contain {{ MIN_NAME_LENGTH }} or more characters
              </mat-error>
            }
            @if (unitShortNameFormControl.hasError('required')) {
              <mat-error>
                Short Name is <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin left">
        <div>
          <p style="font-size: 13px; font-weight: 400; line-height: 1.125; letter-spacing: normal;">
            Description
          </p>
          <div>
            <angular-editor [placeholder]="'Description'" [formControl]="descriptionFormControl" [config]="editorConfig"
              (blur)="saveUnit('description')"></angular-editor>
          </div>
        </div>
      </div>
    </div>
  }
</crucible-dialog>
